declare global {
  interface Window {
    env: any;
  }
}

const apiHost =
  process.env.REACT_APP_API_HOST ||
  (typeof window !== 'undefined' && window.env?.REACT_APP_API_HOST);

/** Swagger UI lives at the API origin root (`/swagger`), not under `/api`. */
const swaggerUrl =
  process.env.REACT_APP_SWAGGER_URL ||
  (typeof window !== 'undefined' && window.env?.REACT_APP_SWAGGER_URL) ||
  (typeof apiHost === 'string'
    ? `${apiHost.replace(/\/api\/?$/, '')}/swagger`
    : undefined);

const config = {
  API_HOST: apiHost,
  SWAGGER_URL: swaggerUrl,
};

export default config;
